import React, { useEffect, useState } from "react";
import { Container, Modal, Button } from "react-bootstrap";
import { Collapse, theme, Card } from 'antd';
import { CDBIcon } from 'cdbreact';
import { useNavigate } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import NavBarPeiix from '../../NavBar';

const Dashboard = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [transacciones, setTransacciones] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const [depositos, setDepositos] = useState([]);
  const [error, setError] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState('Día');
  const [totalSales, setTotalSales] = useState(0);
  const [totalDeposits, setTotalDeposits] = useState(0);
  const { token } = theme.useToken();
  const [showSales, setShowSales] = useState(false);
  const [showDeposits, setShowDeposits] = useState(false);
  const [showNextDeposit, setShowNextDeposit] = useState(false);

  const handleSelect = (period) => {
    setSelectedTime(period); // Actualiza el periodo seleccionado

    // Si hay una sucursal seleccionada, calcula las ventas y depósitos
    if (selectedSucursal) {
      calculateSales(period);
      calculateDeposits(period);
    }
  };

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  const handleSucursalSelect = async (sucursal) => {
    // Cambia la sucursal seleccionada
    setSelectedSucursal(sucursal);
    setSelectedTime(null); // Reinicia el periodo

    // Inicializa los datos en cero
    setTotalSales(0);
    setTotalDeposits(0);
    setTransacciones([]);
    setDepositos([]);

    // Actualiza los tokens
    localStorage.setItem('access_token', sucursal.access_token);
    localStorage.setItem('bp_token', sucursal.bp_token);

    // Obtiene nuevas transacciones y depósitos
    await fetchTransacciones();
    await fetchDepositos();

    // No calculamos los datos aún, ya que el periodo es nulo
  };


  useEffect(() => {
    const fetchSucursales = () => {
      const existingUserTokens = localStorage.getItem('user_tokens_related');
      let sucursalesData = [];

      if (existingUserTokens) {
        try {
          sucursalesData = JSON.parse(existingUserTokens).map(item => ({
            nombre: item.nombre_comercial,
            access_token: item.access_token,
            bp_token: item.bp_token
          }));
        } catch (err) {
          console.error('No se pudo parsear las sucursales:', err);
        }
      }

      const cuentaPrincipal = {
        nombre: localStorage.getItem('nombre_comercial'),
        access_token: localStorage.getItem('access_token'),
        bp_token: localStorage.getItem('bp_token')
      };

      sucursalesData.unshift(cuentaPrincipal);
      setSucursales(sucursalesData);
    };

    fetchSucursales();
  }, []);

  useEffect(() => {
    if (selectedSucursal && selectedTime) {
      calculateSales(selectedTime);
      calculateDeposits(selectedTime);
    }
  }, [selectedSucursal, selectedTime]); // Ejecuta cuando cambian


  const fetchTransacciones = async () => {
    setTransacciones([]); // Limpia las transacciones
    let allTransacciones = [];
    let page = 1;
    const itemsPerPage = 100;

    const dateFrom = new Date(2024, 4, 27, 0, 0);
    const dateTo = new Date();

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:00`;
    };
    const dateFromISO = formatDate(dateFrom);
    const dateToISO = formatDate(dateTo);

    while (true) {
      try {
        const access_token = localStorage.getItem("access_token");
        const bp_token = localStorage.getItem("bp_token");

        if (!access_token || !bp_token) {
          throw new Error("Tokens no disponibles.");
        }

        const response = await fetch(
          `https://dev.masterapi.peiix.com/transactions?dateFrom=${dateFromISO}&dateTo=${dateToISO}&limit=${itemsPerPage}&page=${page}`,
          {
            method: "GET",
            headers: {
              'authorization': access_token,
              'bp-token': bp_token,
            },
          }
        );

        if (response.status === 401) {
          const newTokens = await refreshTokens();
          access_token = newTokens.access_token;
          bp_token = newTokens.bp_token;
          continue;
        }

        if (!response.ok) throw new Error("Error en la solicitud.");

        const data = await response.json();
        allTransacciones = allTransacciones.concat(data.data);
        if (data.data.length < itemsPerPage) break;
        page++;
      } catch (err) {
        setError(err.message);
        console.error("Error al obtener las transacciones:", err);
        break;
      }
    }
    setTransacciones(allTransacciones);
  };

  const fetchDepositos = async () => {
    setDepositos([]);
    let allDepositos = [];
    let page = 1;
    const itemsPerPage = 100;
    const dateFrom = new Date(2024, 4, 27, 0, 0);
    const dateTo = new Date();

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const dateFromISO = formatDate(dateFrom);
    const dateToISO = formatDate(dateTo);

    while (true) {
      try {
        const access_token = localStorage.getItem("access_token");
        const bp_token = localStorage.getItem("bp_token");

        if (!access_token || !bp_token) {
          throw new Error("Tokens no disponibles.");
        }

        const response = await fetch(
          `https://dev.masterapi.peiix.com/depositos?dateFrom=${dateFromISO}&dateTo=${dateToISO}&limit=${itemsPerPage}&page=${page}`,
          {
            method: "GET",
            headers: {
              authorization: access_token,
              "bp-token": bp_token,
            },
          }
        );

        if (response.status === 401) {
          const newTokens = await refreshTokens();
          access_token = newTokens.access_token;
          bp_token = newTokens.bp_token;
          continue;
        }

        if (!response.ok) throw new Error("Error en la solicitud.");

        const data = await response.json();
        allDepositos = allDepositos.concat(data.Data);
        if (data.Data.length < itemsPerPage) break;
        page++;
      } catch (err) {
        setError(err.message);
        console.error("Error al obtener los depósitos:", err);
        break;
      }
    }
    setDepositos(allDepositos);
  };

  const refreshTokens = async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    try {
      const response = await fetch('https://dev.masterapi.peiix.com/refresh', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      });

      if (!response.ok) throw new Error('Error al actualizar tokens.');

      const data = await response.json();
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('bp_token', data.bp_token);
      localStorage.setItem('refresh_token', data.refresh_token);

      return data;
    } catch (error) {
      console.error('Error al refrescar los tokens:', error);
      throw error;
    }
  };

  const calculateSales = (period) => {
    if (!period) return;

    const now = new Date();

    if (!selectedSucursal || !Array.isArray(transacciones)) {
      setTotalSales(0);
      return;
    }

    // Calcular el total de transacciones aprobadas (ventas) y devoluciones en un solo paso usando reduce
    const totalAmounts = transacciones.reduce(
      (totals, transaction) => {
        const transactionDate = new Date(transaction.date);

        // Asegurarse de filtrar por sucursal
        if (transaction.sucursal_id !== selectedSucursal.id) {
          return totals;
        }

        // Calcular solo si están en el período correspondiente
        const isCurrentPeriod =
          (period === 'Día' && transactionDate.toDateString() === now.toDateString()) ||
          (period === 'Semana' && isWithinCurrentWeek(transactionDate, now)) ||
          (period === 'Mes' &&
            transactionDate.getMonth() === now.getMonth() &&
            transactionDate.getFullYear() === now.getFullYear());

        if (isCurrentPeriod) {
          if (transaction.transaction_status === 'aprobada') {
            if (transaction.transaction_type !== 'devolucion') {
              totals.totalAprobadas += parseFloat(transaction.total_amount) || 0;
            } else {
              totals.totalDevoluciones += parseFloat(transaction.total_amount) || 0;
            }
          }
        }

        return totals;
      },
      {
        totalAprobadas: 0,
        totalDevoluciones: 0
      }
    );

    // Cálculo final restando las devoluciones de las transacciones aprobadas
    const total = totalAmounts.totalAprobadas - totalAmounts.totalDevoluciones;

    // Actualizar el estado de las ventas
    setTotalSales(total);
  };

  const calculateDeposits = (period) => {
    if (!period) return;

    const now = new Date();
    let total = 0;

    if (!selectedSucursal || !Array.isArray(depositos)) {
      setTotalDeposits(0);
      return;
    }

    depositos.forEach(deposito => {
      const depositoDate = new Date(deposito.spei_fechahora);
      // Lógica para calcular según el periodo
      if (deposito.spei_estatus === 'ejecutado' && deposito.sucursal_id === selectedSucursal.id) {
        if (period === 'Día' && depositoDate.toDateString() === now.toDateString()) {
          total += deposito.monto;
        } else if (period === 'Semana' && isWithinCurrentWeek(depositoDate, now)) {
          total += deposito.monto;
        } else if (period === 'Mes' && depositoDate.getMonth() === now.getMonth() && depositoDate.getFullYear() === now.getFullYear()) {
          total += deposito.monto;
        }
      }
    });
    setTotalDeposits(total);
  };


  const isWithinCurrentWeek = (date, now) => {
    const weekStart = new Date(now);
    weekStart.setDate(now.getDate() - now.getDay()); // Lunes de esta semana
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6); // Domingo de esta semana
    return date >= weekStart && date <= weekEnd;
  };

  const handleModalClose = () => {
    setModalOpen(false); // Cerrar el modal
    handleLogout(); // Llamar a la función de cerrar sesión
  };

  const tomorrow = new Date();

  // Verificar si hoy es viernes
  if (tomorrow.getDay() === 5) {
    // Si hoy es viernes, establecer la fecha al lunes
    tomorrow.setDate(tomorrow.getDate() + 3); // Sumar 3 días para obtener el lunes
  } else {
    tomorrow.setDate(tomorrow.getDate() + 1); // Sumar un día
  }

  // Formato de la fecha como "Martes, 29 de Octubre de 2024"
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  let formattedTomorrow = tomorrow.toLocaleDateString('es-ES', options);

  // Capitalizar la primera letra del día y del mes
  const capitalizeFirstLetter = (string) => {
    return string
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  formattedTomorrow = capitalizeFirstLetter(formattedTomorrow);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("access_token"); // Limpia el token de autenticación
    localStorage.removeItem("bp_token");
    navigate("/Inicio"); // Redirigir a la página de inicio de sesión
  };

  return (
    <>
      <div className="Dashboard">
        <NavBarPeiix />

        <div className='navbar-container' style={{ padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className='navbar-imgl' style={{ flex: '0 0 auto' }}>
            <h3 className=" fw-bold" style={{ color: '#3E3E3E', fontFamily: 'Montserrat, sans-serif', marginBottom: '0', display: 'flex', alignItems: 'center' }}>
              <CDBIcon icon="th-large" /> Resumen
            </h3>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle caret style={{
                height: 'auto',
                borderRadius: '5px',
                border: '1px solid #F2F2F2',
                backgroundColor: '#F2F2F2',
                color: '#3E3E3E',
                fontWeight: 'bold',
                fontFamily: 'Montserrat, sans-serif',
              }}>
                <CDBIcon icon="map-marker-alt" />
                {sucursales.length > 0 ? (
                  selectedSucursal ? selectedSucursal.nombre : "Sucursales"
                ) : (
                  "Sin Sucursales"
                )}
              </DropdownToggle>
              <DropdownMenu>
                {sucursales.map((sucursal, index) => (
                  <DropdownItem key={index} onClick={() => handleSucursalSelect(sucursal)}>
                    {sucursal.nombre}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>


        <div className="button-group mt-2 mb-2" style={{ display: 'flex', gap: '5px', borderRadius: '15px', paddingLeft: '50px', fontFamily: 'Montserrat, sans-serif' }}>
          {['Día', 'Semana', 'Mes'].map((period) => (
            <button
              key={period}
              className={`btn ${selectedTime === period ? 'btn-secondary' : 'btn-outline-secondary'}`}
              style={{
                height: 'auto',
                borderRadius: '8px',
                border: '1px solid #cccccc',
                backgroundColor: selectedTime === period ? '#9A9A9A' : '#F2F2F2', // Fondo verde si está seleccionado, blanco si no
                color: selectedTime === period ? 'white' : '#686868', // Color de texto
                fontWeight: 'bold',
                padding: '10px 20px',
                boxShadow: selectedTime === period ? '0 0 5px rgba(0,0,0,0.2)' : 'none',
                transition: 'background-color 0.3s, border-color 0.3s', // Transición suave para el cambio de colores
              }}
              onClick={() => handleSelect(period)}
              onMouseDown={(e) => e.target.style.backgroundColor = selectedTime === period ? '#3E4144' : '#E0E0E0'}
              onMouseUp={(e) => e.target.style.backgroundColor = selectedTime === period ? '#9A9A9A' : '#F2F2F2'}
            >
              {period}
            </button>
          ))}
        </div>


        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            gap: '50px',
            padding: '50px',
          }}
        >
          <Card style={{ width: 300, background: showSales ? '#D9FFD5' : '#9A9A9A', color: showSales ? '#3E3E3E' : '#FFFFFF', border: showSales ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s, border-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
            <div
              style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
              onClick={() => setShowSales(!showSales)}
            >
              {showSales ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
            </div>
            <div style={{ marginTop: '10px' }}>
              <p style={{ textAlign: 'left' }} className="fw-bold h4">
                {showSales ? `$${totalSales.toLocaleString()}` : '******'}
              </p>
            </div>
            <p style={{ textAlign: 'left' }} className="fw-bold h5">Mis ventas</p>
          </Card>

          <Card style={{ width: 300, background: showDeposits ? '#D9FFD5' : '#9A9A9A', color: showDeposits ? '#3E3E3E' : '#FFFFFF', border: showDeposits ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s, border-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
            <div
              style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
              onClick={() => setShowDeposits(!showDeposits)}
            >
              {showDeposits ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
            </div>
            <div style={{ marginTop: '10px' }}>
              <p style={{ textAlign: 'left' }} className="fw-bold h4">
                {showDeposits ? `$${totalDeposits.toLocaleString()}` : '******'}
              </p>
            </div>
            <p style={{ textAlign: 'left' }} className="fw-bold h5">Mis depósitos</p>
          </Card>

          <Card style={{ width: 500, background: showNextDeposit ? '#D9FFD5' : '#9A9A9A', color: showNextDeposit ? '#3E3E3E' : '#FFFFFF', border: showNextDeposit ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s, border-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
            <div
              style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
              onClick={() => setShowNextDeposit(!showNextDeposit)}
            >
              {showNextDeposit ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
            </div>
            <div style={{ marginTop: '10px' }}>
              <p style={{ textAlign: 'left' }} className="fw-bold h4">
                {showNextDeposit ? formattedTomorrow : '******'}
              </p>
            </div>
            <p style={{ textAlign: 'left' }} className="fw-bold h5">Fecha próximo depósito</p>
          </Card>
        </div>

        {/* Modal de sesión expirada */}
        <Modal show={isModalOpen} onHide={handleModalClose}>
          <Modal.Body>
            <Container
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CDBIcon
                icon="exclamation-circle"
                size="7x"
                style={{ color: "#ff6961" }}
              />
            </Container>
            <br />
            <Container>
              <h3 className="fw-bold" style={{ textAlign: "center" }}>
                Tu sesión ha expirado. Por favor, cierra sesión y vuelve a
                iniciar.
              </h3>
            </Container>
            <br />
            <Container
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Button
                variant="secondary"
                style={{ background: "#ff6961", border: "#ff6961" }}
                onClick={handleModalClose}
              >
                <div className="fw-bold h5">Aceptar</div>
              </Button>
            </Container>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Dashboard;